import { forwardRef } from "react";
import PropTypes from "prop-types";

import colors from "constants/colors";

import { CheckboxStyled, Content, Input, Box, Text } from "./Checkbox.styled";
import IconCheck from "../svg/IconCheck";

const Checkbox = forwardRef(({ type, label, name, id, ...props }, ref) => {
    return (
        <CheckboxStyled htmlFor={name}>
            <Input {...props} type={type} ref={ref} name={name} id={id} />
            <Content>
                <Box>
                    <IconCheck fill={colors.peach} />
                </Box>
                {label && <Text>{label}</Text>}
            </Content>
        </CheckboxStyled>
    );
});

Checkbox.defaultProps = {
    type: "checkbox",
    name: "checkbox",
    label: undefined,
    value: "true"
};

Checkbox.propTypes = {
    type: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    value: PropTypes.any,
    id: PropTypes.string.isRequired
};

export default Checkbox;
